import CBSearchTextFieldController from "../controller/CBSearchTextFieldController";

const CBLastNameSearchFilter = () => {

    return (
        <CBSearchTextFieldController
            idField="lastName"
            formName="lastName"
            label="lastName"
        />
    )
}

export default CBLastNameSearchFilter;